import React, { useState } from 'react';
import { Container, Typography, Button, Box, Alert, Paper, CircularProgress } from '@mui/material';
import axios from '../../services/apiClient';

const ImportData = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResult(null);
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return;
    setLoading(true);
    setResult(null);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await axios.post('/api/gtfs/import', formData);
      setResult(res.data);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Hiba történt az importálás során');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        GTFS importálás
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body1">
            Tölts fel egy érvényes GTFS ZIP állományt. A feltöltés törli a korábbi GTFS adatokat és az újakat importálja.
          </Typography>
          <input
            type="file"
            accept=".zip"
            onChange={handleFileChange}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={!file || loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Importálás'}
          </Button>
          {result && (
            <Alert severity="success">
              Sikeres import: {result.stats.stops} megálló, {result.stats.routes} járat, {result.stats.trips} viszonylat, {result.stats.stopTimes} indulás.
            </Alert>
          )}
          {error && (
            <Alert severity="error">{error}</Alert>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default ImportData;
